var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPrintGrey = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "print",
    d: "M3.75,6.25H2.5V2.5A2.5,2.5,0,0,1,5,0h8.965a2.5,2.5,0,0,1,1.77.73L16.77,1.766a2.5,2.5,0,0,1,.73,1.77V6.25H16.25V3.535a1.248,1.248,0,0,0-.367-.883L14.848,1.617a1.248,1.248,0,0,0-.883-.367H5A1.249,1.249,0,0,0,3.75,2.5ZM17.5,8.75H2.5A1.249,1.249,0,0,0,1.25,10v5H2.5V13.75A1.249,1.249,0,0,1,3.75,12.5h12.5a1.249,1.249,0,0,1,1.25,1.25V15h1.25V10A1.249,1.249,0,0,0,17.5,8.75Zm0,7.5v2.5A1.249,1.249,0,0,1,16.25,20H3.75A1.249,1.249,0,0,1,2.5,18.75v-2.5H1.25A1.249,1.249,0,0,1,0,15V10A2.5,2.5,0,0,1,2.5,7.5h15A2.5,2.5,0,0,1,20,10v5a1.249,1.249,0,0,1-1.25,1.25ZM3.75,13.75v5h12.5v-5ZM16.875,9.688a.938.938,0,1,1-.937.938A.938.938,0,0,1,16.875,9.688Z",
    fill: "#1a1a1a"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPrintGrey);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/print-grey.1b7bb6ef45adf0a8f2640955c5da8e8a.svg";